import { useMutation } from 'react-query';

import {
  useRequest,
  type MutationFunction,
  type RequestQueryObject,
} from '@frontend/api';

export const getUseDeleteRuleKey = (uuid: string) =>
  ['rules', 'delete', uuid] as const;

/**
 * Mutation function for deleting a rule.
 */
export const useDeleteRule: MutationFunction<
  unknown,
  unknown,
  [{ uuid: string }],
  RequestQueryObject
> = ({ uuid }, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    () =>
      request(`/rules/${uuid}`, {
        init: {
          method: 'DELETE',
        },
      }),
    {
      ...queryOptions,
      mutationKey: getUseDeleteRuleKey(uuid),
    },
  );
};
